<script setup lang="ts">
import AppButton from "~/components/Common/Buttons/AppButton.vue";
import CommonInput from "~/components/Common/Inputs/CommonInput.vue";

const props = withDefaults(
  defineProps<{
    modelValue: string;
    disabled?: boolean;
  }>(),
  { disabled: false },
);

const emit = defineEmits<{
  "update:modelValue": [value: string];
  submit: [];
}>();

const containerRef = ref<HTMLElement | null>(null);

/** Enter and the button submit on the same condition — an empty URL starts no analysis. */
function onSubmit() {
  if (props.disabled || !props.modelValue.trim()) return;

  emit("submit");
}

function focus() {
  containerRef.value?.querySelector("input")?.focus();
}

defineExpose({ focus });
</script>

<template>
  <div ref="containerRef" class="flex w-full items-center gap-2" @keydown.enter.prevent="onSubmit()">
    <CommonInput
      :model-value="modelValue"
      type="url"
      class="min-w-0 flex-1 text-left"
      placeholder="Lien d'un programme (https://...)"
      :disabled="disabled"
      @update:model-value="emit('update:modelValue', $event)"
    />
    <AppButton label="Analyser" :disabled="disabled || !modelValue.trim()" @click="onSubmit()" />
  </div>
</template>
